import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_RESOURCE_LIBRARY_NEW_PRODUCT_INTRODUCTION_ITEMS_QUERY = queryWithFallbackKey(
    gql`
        query getResourceLibraryNewProductIntroductionItemListing(
            $defaultLanguage: String!
            $filter: String
            $first: Int
            $after: Int
            $sortBy: [String]
            $sortOrder: [String]
        ) {
            getResourceLibraryNewProductIntroductionItemListing(
                defaultLanguage: $defaultLanguage
                filter: $filter
                first: $first
                after: $after
                sortBy: $sortBy
                sortOrder: $sortOrder
            ) {
                edges {
                    node {
                        id
                        key
                        name
                        description
                        coverImage {
                            fullpath
                        }
                        brand {
                            ... on object_Brand {
                                id
                            }
                        }
                        productGroup {
                            ... on object_ProductGroup {
                                id
                            }
                        }
                        productApplication {
                            ... on object_ProductApplicationSegment {
                                id
                            }
                            ... on object_ProductApplication {
                                id
                            }
                        }
                        resourceType {
                            ... on object_ResourceType {
                                id
                            }
                            ... on object_ResourceTypeGroup {
                                id
                            }
                        }
                        navigationScope {
                            ... on object_NavigationNode {
                                id
                            }
                        }
                        exclusiveNavigationScope {
                            ... on object_NavigationNode {
                                id
                            }
                        }
                        publicationDate
                        thumbnailUrl: thumbnail
                    }
                }
            }
        }
    `,
    'GET_RESOURCE_LIBRARY_NEW_PRODUCT_INTRODUCTION_ITEMS_QUERY'
);

export function getResourceLibraryNewProductIntroductionItemsQueryVariables(
    localeCode: LocaleCode,
    filter?: string,
    first?: number,
    after?: number,
    sortBy?: string[],
    sortOrder?: string[]
) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
        filter: filter ?? null,
        first: first ?? null,
        after: after ?? null,
        sortBy: sortBy ?? null,
        sortOrder: sortOrder ?? null,
    };
}
